import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Typography
} from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { firestore } from '../../../../../contexts/FirebaseContext';
import { PaymentReports } from '../../../wallet/DialogHistory';
import UserWallet from '../UserWallet';
import UserWalletEventsInfo from './UserWalletEvents';

function UserWalletInfo({ data }) {
  const [openDialog, setOpenDialog] = useState(false);
  return (
    <Card sx={{ padding: '15px', textAlign: 'center', marginTop: '15px' }}>
      <Box>
        <Typography variant="subtitle1">Informacion de la wallet</Typography>
        <Divider />
      </Box>
      <Box sx={{ marginTop: '15px', padding: '15px', display: 'flex', justifyContent: 'center' }}>
        <Button variant="contained" color="info" onClick={() => setOpenDialog(true)}>
          ver wallet
        </Button>
        <DialogWallet open={openDialog} onClose={setOpenDialog} userData={data} />

        <UserWalletEventsInfo userData={data} />
      </Box>
    </Card>
  );
}

export default UserWalletInfo;

function DialogWallet({ open, onClose, userData }) {
  const [transactions, setTransactions] = useState([]);
  const handleClose = () => {
    onClose(false);
  };

  useEffect(() => {
    async function getransactionsUser() {
      await firestore
        .collection('transactionUsers')
        .where('user_id', '==', userData.id)
        .orderBy('updated_at', 'desc')
        .onSnapshot((queryS) => {
          const dat = [];
          queryS.forEach((doc) => {
            dat.push({
              id: doc.id,
              ...doc.data()
            });
          });
          // console.log('datos del user', dat);
          setTransactions(dat);
        });
    }
    getransactionsUser();
  }, [userData]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xl"
      fullWidth
    >
      {/* <DialogTitle sx={{ textAlign: 'center' }} id="alert-dialog-title">
        Wallet del usuario
      </DialogTitle> */}
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <UserWallet userId={userData.id} />
          </Grid>
          <Grid item xs={12} md={8}>
            <PaymentReports transactions={transactions} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" startIcon={<KeyboardBackspaceIcon />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
